/**
 * The interface for an error log message.
 * @see LogService
 */
export default interface IErrorLogMsg {
    httpResponseCode: number;
    customerNumber: number;
    passportId: number;
    ipAddress: string;
    message: string;
    dataString: string;
}

export function newErrorLogMsg(): IErrorLogMsg {
    const result: IErrorLogMsg = {
        httpResponseCode: 0,
        customerNumber: 0,
        passportId: 0,
        ipAddress: '',
        message: '',
        dataString: ''
    };
    return result;
}
